// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_n5-0";